import { SignUpTranslation } from "@/AutoEnrollment/ui/autoEnrollmentTranslation"
import { handleErrors } from "@/Shared/ui/form"
import { OreButton, OreHeading, OreInput, OreStack, OreText } from "@edenredespana/oreneta"
import { useFormContext } from "react-hook-form"
import { Trans, useTranslation } from "react-i18next"
import { OtpForm } from "../hooks"
import { LoginTranslation } from "../accountTranslation"
import { useLocation } from "react-router-dom"

interface CreateAccountOtpFormProps {
  isBlocked: boolean
  errorMessage: string
  handleOtpResend: () => void
}

export const CreateAccountOtpForm = ({ isBlocked, errorMessage, handleOtpResend }: CreateAccountOtpFormProps): JSX.Element => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const { register, formState } =
    useFormContext<OtpForm>()
  const { errors } = handleErrors(formState)

  const { fromRegisterPage } = state ?? false

  return (
    <>
      {fromRegisterPage ? (

        <OreStack space="large" placeContent="stretch" placeItems="start">
          <OreHeading as="h2" size="headline-lg">{t(LoginTranslation.register.otpForm.title)}</OreHeading>

          <OreText size="text-md" tone="neutral-600">
            <Trans t={t} components={
              [
                <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}`} />
              ]
            }>
              {t(LoginTranslation.otp.subtitle, {
                USER_EMAIL: state?.otpEmail ?? '',
                CONTACT_PHONE: t(SignUpTranslation.otp.tel),
                CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
              })}
            </Trans>
          </OreText>

          <OreInput
            {...register('otp')}
            type="number"
            label={t(LoginTranslation.otp.form.codeLabel)}
            placeholder={t(SignUpTranslation.otp.code.placeholder)}
            hasError={!!formState.errors.otp}
            errorMessage={formState.errors.otp?.message}
            required
          />

          <OreText>
            {t(LoginTranslation.otp.resendCode)}{' '}
            <OreButton
              style={{
                textDecoration: 'underline',
                fontFamily: 'Ubuntu, sans-serif',
                fontWeight: 'normal'
              }}
              onClick={(): void => { handleOtpResend() }}
              disabled={isBlocked}
            >{t(LoginTranslation.otp.resendCodeLink)}
            </OreButton>
          </OreText>
          {isBlocked && (
            <OreStack placeItems="center" placeContent="center">
              <OreText align="center" size="text-xs">
                {errorMessage}
              </OreText>
            </OreStack>
          )}

        </OreStack>

      ) : (
        <p>404, Not Found</p>
      )}
    </>
  )
}